import { GlButton } from '@gitlab/ui';
import { mapActions, mapState } from 'pinia';
import { createAlert } from '~/alert';
import { __, n__ } from '~/locale';
import { useBatchComments } from '~/batch_comments/store';
import { useNotes } from '~/notes/store/legacy_notes';
export default {
    name: 'SubmitReviewButton',
    components: {
        GlButton
    },
    computed: {
        ...mapState(useNotes, [
            'isNotesFetched'
        ]),
        ...mapState(useBatchComments, [
            'draftsCount',
            'isDraftsFetched',
            'isReviewer',
            'shouldAnimateReviewButton'
        ]),
        isLoading () {
            return !this.isNotesFetched || !this.isDraftsFetched;
        },
        draftsCountSrText () {
            return n__('draft', 'drafts', this.draftsCount);
        }
    },
    mounted () {
        this.fetchDrafts().catch((error)=>{
            createAlert({
                message: __('An error occurred while fetching pending comments'),
                captureError: true,
                error
            });
        });
    },
    methods: {
        ...mapActions(useBatchComments, [
            'fetchDrafts',
            'setDrawerOpened'
        ])
    }
};
